<template>
  <div class="logo">
    <img v-if="isTransparent" src="/static/home/logo/logo1.png" style="width:132px;" />
    <img v-else src="/static/home/logo/logo2.png" style="width:132px;" />
  </div>
</template>
<script>
export default {
  name: "logo",
  props: {
    isTransparent: {
      type: Boolean,
      default: false
    }
  }
};
</script>
